import {
  CodeSlash,
  TypeBold,
  TypeItalic,
  TypeStrikethrough,
  TypeUnderline,
} from '@styled-icons/bootstrap';
import { getPreventDefaultHandler, isMarkActive, toggleMark } from '@udecode/plate-core';
import classNames from 'classnames';
import { memo, ReactElement } from 'react';
import Tooltip from '../../../../components/Tooltip';
import { useTPlateEditorRef } from '../../../../plate';
import { useDreamEditorStore } from '../../../../plugins/store';
import { getCmdCtrlSymbol } from '../../../../utils/cmdCtrl';
import toolbarStyles from '../../SideToolbar.module.css';
import styles from './TextFormat.module.css';

interface ToolbarMarkProps {
  type: 'bold' | 'code' | 'italic' | 'strikethrough' | 'underline'
  icon: ReactElement
}

function ToolbarMark(props: ToolbarMarkProps) {
  const { type, icon } = props;
  const editor = useTPlateEditorRef();

  // Recalculate every time editor updated.
  // We avoid using useTEditorState for performance
  const isActive = useDreamEditorStore(() => isMarkActive(editor, type));

  return (
    <button
      type="button"
      className={classNames(styles.markButton, { [styles.active]: isActive })}
      onMouseDown={getPreventDefaultHandler(toggleMark, editor, { key: type })}
    >
      {icon}
    </button>
  );
}

function TextFormat() {
  const symbol = getCmdCtrlSymbol();

  return (
    <div className={toolbarStyles.section}>
      <span className={toolbarStyles.label}>
        Text Format
      </span>
      <div className={toolbarStyles.menuGroup}>
        <div className={toolbarStyles.menuItem}>
          <Tooltip center="Bold" right={`${symbol} B`}>
            <ToolbarMark type="bold" icon={<TypeBold size={20} />} />
          </Tooltip>
          <Tooltip center="Underline" right={`${symbol} U`}>
            <ToolbarMark type="underline" icon={<TypeUnderline size={20} />} />
          </Tooltip>
          <Tooltip center="Italic" right={`${symbol} I`}>
            <ToolbarMark type="italic" icon={<TypeItalic size={20} />} />
          </Tooltip>
          <Tooltip center="Strikethrough">
            <ToolbarMark
              type="strikethrough"
              icon={<TypeStrikethrough size={20} />}
            />
          </Tooltip>
          <Tooltip center="Inline Code">
            <ToolbarMark type="code" icon={<CodeSlash size={20} />} />
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default memo(TextFormat);
